// extracted by mini-css-extract-plugin
module.exports = {"pxp-bath-logo-video-container":"BathLogoVideo_pxp-bath-logo-video-container__uUcoq","__video-container":"BathLogoVideo___video-container__MIC9d"};